import React from 'react';
import '../css/ImportantWebsites.css';
import aicte from '../image/aicte.png';
import delnet from '../image/delnet.jpg';
import Img from '../image/download1.png';
import Img2 from '../image/download3.png';
import Img3 from '../image/download.jpeg'
import Img4 from '../image/emailnew.svg';
import Img5 from '../image/location (1).svg';

function ImportantWebsites() {
  const logos = [
    { src: aicte, alt: 'INFLIBNET' },
    { src: delnet, alt: 'UGC FHEI' },
    { src: Img, alt: 'NIRF' },
    { src: Img2, alt: 'AISHE' },
    { src: Img3, alt: 'SWAYAM' },
  ];

  return (
    <div className="important-section">
      <h2 className="section-title"> Important Websites</h2>
      <div className="logos-wrapper">
        <div className="logos-slider">
          {logos.map((logo, index) => (
            <img key={index} src={logo.src} alt={logo.alt} className="logo-img" />
          ))}
        </div>
      </div>

      <div className="contact-section">
        <h2 className="section-title">📩 Contact Us</h2>
        <h3 className="contact-heading">Need Help? Say Hello</h3>
        <div className="contact-details">
          <div className="contact-item">
            <img src={Img5} alt="Email" />
            S.N.SINHA College, Warisaliganj, Bihar
          </div>
          <div className="contact-item">
            <img src={Img4} alt="Email" className="contact-icon" />
            snscwrs@gmail.com
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImportantWebsites;
